import RecurringDepositsList from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/AutoDepositSection/components/RecurringDepositsList';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';

const AutoDepositSection = () => {
  return (
    <ProfileSection title={'Recurring deposits'}>
      <RecurringDepositsList />
    </ProfileSection>
  );
};
export default AutoDepositSection;
